module.exports = __webpack_public_path__ + "media/images/proof_links/proof_green/wiki-1da8376bc5ab5378fdd8a5072dadc0b0.svg";